// Validation rules for zip codes to use with Ant Design forms

export const createZipValidationRules = (options = {}) => {
  const {
    required = true,
    requiredMessage = 'Please enter a ZIP code',
    patternMessage = 'Please enter a valid 5-digit ZIP code',
  } = options

  const rules = []

  if (required) {
    rules.push({
      required: true,
      message: requiredMessage,
    })
  }

  rules.push({
    pattern: /^\d{5}$/,
    message: patternMessage,
  })

  return rules
}

// Common zip validation rule for convenience
export const defaultZipRules = createZipValidationRules()

// Validate a zip code string
export const isValidZipCode = (zipCode) => {
  if (!zipCode) {
    return false
  }
  return /^\d{5}$/.test(zipCode.toString())
}
